import React from "react";

const PlaybackIcon = () => {
  return (
    <svg
      aria-hidden={true}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4436_60167)">
        <path
          d="M8 14.6663C11.6819 14.6663 14.6667 11.6815 14.6667 7.99967C14.6667 4.31777 11.6819 1.33301 8 1.33301"
          stroke="#666666"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M7.99967 14.6663C4.31777 14.6663 1.33301 11.6815 1.33301 7.99967C1.33301 4.31777 4.31777 1.33301 7.99967 1.33301"
          stroke="#666666"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeDasharray="1 3"
        />
        <path
          d="M10.2758 7.29367C10.7969 7.60141 10.7969 8.39794 10.2758 8.70567L7.129 10.5635C6.62247 10.8626 6 10.4733 6 9.85754V6.14178C6 5.52599 6.62247 5.13675 7.129 5.4358L10.2758 7.29367Z"
          stroke="#666666"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_4436_60167">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlaybackIcon;
